import {
  validateEmail,
  validateRequired,
  Validator,
} from 'application/utils/validators';

// <SET_IS_MODULE_LOADED>
export const SET_IS_MODULE_LOADED = '[form] sec-extra-short module/isModuleLoaded'; // eslint-disable-line max-len
export type SetIsModuleLoadedAction = {
  type: typeof SET_IS_MODULE_LOADED,
};
export const setIsModuleLoaded = {
  type: SET_IS_MODULE_LOADED,
};
// </SET_IS_MODULE_LOADED>

// <SUBMIT_FORM_SEC_EXTRA_SHORT>
export const SUBMIT_FORM_SEC_EXTRA_SHORT = '[form] submit 1st step sec extra short'; // eslint-disable-line max-len
export type SubmitForm = {
  type: typeof SUBMIT_FORM_SEC_EXTRA_SHORT;
}
export const submitForm = {
  type: SUBMIT_FORM_SEC_EXTRA_SHORT,
};
// </SUBMIT_FORM_SEC_EXTRA_SHORT>

// <RESET_FORM_SEC_EXTRA_SHORT>
export const RESET_FORM_SEC_EXTRA_SHORT = '[sec-callback] SEC extra short form reset'; // eslint-disable-line max-len
export type ResetForm = {
  type: typeof RESET_FORM_SEC_EXTRA_SHORT,
};

export const resetForm: ResetForm = {
  type: RESET_FORM_SEC_EXTRA_SHORT,
};
// </RESET_FORM_SEC_EXTRA_SHORT>

// <SET_FORM_LOADING_SEC_EXTRA_SHORT>
export const SET_FORM_LOADING_SEC_EXTRA_SHORT = '[forms] set loading sec extra short'; // eslint-disable-line max-len
export type SetFormLoading = {
  type: typeof SET_FORM_LOADING_SEC_EXTRA_SHORT;
  payload: {
    isLoading: boolean;
  }
};

export const setFormLoading = (
  isLoading: boolean,
): SetFormLoading => ({
  type: SET_FORM_LOADING_SEC_EXTRA_SHORT,
  payload: {
    isLoading,
  },
});
// </SET_FORM_LOADING_SEC_EXTRA_SHORT>

// <SET_FORM_SUCCESS_SEC_EXTRA_SHORT>
export const SET_FORM_SUCCESS_SEC_EXTRA_SHORT = '[forms] set success sec extra short'; // eslint-disable-line max-len
export type SetFormSuccess = {
  type: typeof SET_FORM_SUCCESS_SEC_EXTRA_SHORT;
  payload: {
    isSuccess: boolean;
  }
};

export const setFormSuccess = (
  isSuccess: boolean,
): SetFormSuccess => ({
  type: SET_FORM_SUCCESS_SEC_EXTRA_SHORT,
  payload: {
    isSuccess,
  },
});
// </SET_FORM_SUCCESS_SEC_EXTRA_SHORT>

// <SET_INPUT_SEC_EXTRA_SHORT>
export const SET_INPUT_SEC_EXTRA_SHORT = '[forms] input change sec extra short';

export type SetInput = {
  type: typeof SET_INPUT_SEC_EXTRA_SHORT;
  payload: {
    fieldName: string;
    value: string;
    validators: Validator[];
  }
}
export type SetInputValidated = {
  type: typeof SET_INPUT_SEC_EXTRA_SHORT;
  payload: {
    [fieldName: string]: {
      value: string;
      error: string;
    }
  }
}

export const setRequiredInput = (fieldName: string) => (
  value: string,
): SetInput => ({
  type: SET_INPUT_SEC_EXTRA_SHORT,
  payload: {
    fieldName,
    value,
    validators: [validateRequired],
  },
});

export const setRequiredEmail = (fieldName: string) => (
  value: string,
): SetInput => ({
  type: SET_INPUT_SEC_EXTRA_SHORT,
  payload: {
    fieldName,
    value,
    validators: [validateRequired, validateEmail],
  },
});
// </SET_INPUT_SEC_EXTRA_SHORT>

// <SET_CHECKBOX_SEC_EXTRA_SHORT>
export const SET_CHECKBOX_SEC_EXTRA_SHORT = '[forms] checkbox change sec extra short'; // eslint-disable-line max-len

export type SetCheckbox = {
  type: typeof SET_CHECKBOX_SEC_EXTRA_SHORT,
  payload: {
    groupName: string,
    option: string,
    isChecked: boolean,
    validators: Validator[],
  }
}

export type SetCheckboxValidated = {
  type: typeof SET_CHECKBOX_SEC_EXTRA_SHORT;
  payload: {
    [groupName: string]: {
      value: { [key: string]: boolean; };
      error: string;
    }
  }
}

export const setCheckbox = (
  groupName: string,
  option: string,
) => (
  isChecked: boolean,
): SetCheckbox => ({
  type: SET_CHECKBOX_SEC_EXTRA_SHORT,
  payload: {
    groupName,
    option,
    isChecked,
    validators: [],
  },
});
// </SET_CHECKBOX_SEC_EXTRA_SHORT>

// <SET_GENERAL_ERROR_SEC_EXTRA_SHORT>
export const SET_GENERAL_ERROR_SEC_EXTRA_SHORT = 'set general error sec extra short'; // eslint-disable-line max-len
export type SetGeneralErrorMessage = {
  type: typeof SET_GENERAL_ERROR_SEC_EXTRA_SHORT;
  payload: string;
}

export const setGeneralErrorMessage = (
  message: SetGeneralErrorMessage['payload'],
): SetGeneralErrorMessage => ({
  type: SET_GENERAL_ERROR_SEC_EXTRA_SHORT,
  payload: message,
});
// </SET_GENERAL_ERROR_SEC_EXTRA_SHORT>

// <SHOW_SECOND_STEP_SEC_EXTRA_SHORT>
export const SHOW_SECOND_STEP_SEC_EXTRA_SHORT = '[forms] show 2nd step sec extra short'; // eslint-disable-line max-len

export type ShowSecondStep = {
  type: typeof SHOW_SECOND_STEP_SEC_EXTRA_SHORT,
};
export const showSecondStep = {
  type: SHOW_SECOND_STEP_SEC_EXTRA_SHORT,
};
// </SHOW_SECOND_STEP_SEC_EXTRA_SHORT>

// <SET_CAMPAIGN_SEC_EXTRA_SHORT>
export const SET_CAMPAIGN_SEC_EXTRA_SHORT = 'set campaign data sec extra short';
export type SetCampaign = {
  type: typeof SET_CAMPAIGN_SEC_EXTRA_SHORT,
  payload: {
    name: string,
    source: string,
    medium: string,
  }
}
export const setCampaign = (
  campaign: SetCampaign['payload'],
): SetCampaign => ({
  type: SET_CAMPAIGN_SEC_EXTRA_SHORT,
  payload: campaign,
});
// </SET_CAMPAIGN_SEC_EXTRA_SHORT>

export type SecCallbackActions =
  | SetIsModuleLoadedAction
  | SetInputValidated
  | SetCheckboxValidated
  | SetCampaign
  | SetFormLoading
  | SetFormSuccess
  | ShowSecondStep
  | SetGeneralErrorMessage
  | ResetForm;
